export default __webpack_public_path__ + "static/media/regulatory--no-left-or-u-turn--g1.b309afb9.png";